export default class ViewDynamicVO
{

	// ----------------------------------
	//	Properties
	// ----------------------------------

	//defaultValue = [];
	name = "Dynamic field";
	fieldType = 'dynamicField';
	uiComponent = 'view-dynamic-field';
	description = 'A super field which can contain any other fields, dynamicly added by the user.';

	fieldTypesAvailable = [];
	
	constructor()
	{
		
	}
}